export default __webpack_public_path__ + "static/media/Resume1-page-001.ea5e716b.jpg";